import React, { useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { ProductContext } from "lib/productContext";
import AdditionalSale from "../additionalSale/AdditionalSale";

function Packaging({ id, packagingRef }) {
    const [options, setOptions] = useState();

    const { productData, productLoading, productError } = useContext(
        ProductContext
    );

    function setPackingOptions() {
        const packagingItems = productData?.product?.packaging?.edges;

        if (!options) {
            if (!productLoading && !productError && packagingItems) {
                setOptions(productData.product.packaging.edges);
            }
        }
    }

    useMemo(setPackingOptions, [
        options,
        productData,
        productError,
        productLoading
    ]);

    return (
        <AdditionalSale
            title="Kies een mooie verpakking voor de cadeaukaart"
            type="packaging"
            items={options}
            id={id}
            ref={packagingRef}
        />
    );
}

Packaging.defaultProps = {
    id: undefined,
    packagingRef: undefined
};

Packaging.propTypes = {
    id: PropTypes.string,
    packagingRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ])
};

export default Packaging;
